var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"frameborder":"0","height":"1000","width":"100%","src":"https://www.jlassure.com/sousfiche/assure_tempo_rapide_mb.php?cat=&&tip=09.73.45.49.07&&id=1258&&cd=17RET106&&adrsite=https://partenaires.dynassurances.fr/"}},[_vm._v("Votre navigateur ne supporte pas les IFrames.")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25316910","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Garantie/AssuranceTemporaire.vue
// module id = null
// module chunks = 